import { Theme } from "@mui/material/styles";

export default function Tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: theme.palette.text.primary,
          borderRadius: "8px",
          padding: "6px 10px",
          fontSize: `11px`,
          // boxShadow:
          //   "inset 0 0 0.5px 1px hsla(0, 0%,  100%, 0.075), 0 0 0 1px hsla(0, 0%, 0%, 0.05),0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),0 3.5px 6px hsla(0, 0%, 0%, 0.09)",
          color: theme.palette.background.paper,
          fontWeight: 400,
        },
        arrow: {
          color: theme.palette.text.primary,
        },
      },
    },
  };
}
